import { useQuery } from '@tanstack/react-query';
import { OutageNotificationsClient } from '@@/api/api-outage-notifications';

export const usePageLocations = () => {
  const { data, isLoading, isFetching, isError, error } = useQuery({
    queryKey: ['page-locations'],
    queryFn: async () => {
      const client = new OutageNotificationsClient();
      const result = await client.getPageLocations();
      if (!result.ok) {
        throw new Error(result.message ?? 'Failed to load page locations');
      }
      return result.data.pageLocations ?? [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000
  });

  return {
    locations: data ?? [],
    isLoading,
    isFetching,
    isError,
    error
  };
};
